import * as Yup from "yup";
const whiteSpaceRegex = /^.*\S.*$/;

export const commonPersonPayload = {
  gender: "",
  firstName: "",
  lastName: "",
  salutaion: "",
  pan: "",
  passport: {},
};

export const personSchema = Yup.object().shape({
  type: Yup.string().required("Type is required"),
  gender: Yup.string().required("Gender is required"),
  firstName: Yup.string()
    .required("First name is required")
    .min(2, "First name must be at least 2 characters")
    .max(100, "First name must be at most 100 characters")
    .matches(whiteSpaceRegex, "First name is required"),
  lastName: Yup.string()
    .required("Last name is required")
    .min(2, "Last name must be at least 2 characters")
    .max(100, "Last name must be at most 100 characters")
    .matches(whiteSpaceRegex, "Last name is required"),
});

export const validationSchema = Yup.object().shape({
  roomInfoValues: Yup.array()
    .of(
      Yup.object().shape({
        adults: Yup.array()
          .of(personSchema)
          .min(1, "At least one adult is required"),
        childs: Yup.array().of(personSchema),
      })
    )
    .min(1, "At least one room is required"),
  contactDetails: Yup.object().shape({
    phoneNumber: Yup.string()
    .required("Phone number is required")
    .max(15, "Max 15 digits allowed")
    .min(5, "Min 5 digits allowed")
    .matches(whiteSpaceRegex, "No spaces allowed")
    .matches(/^[0-9]+$/, "Only numbers allowed"),
    phoneCode: Yup.mixed().required("Phone code is required"),
    email: Yup.string()
    .required("Email is required")
    .email("Please enter a valid email")
    .matches(/^\S+@\S+\.\S+$/, "Please enter a valid email")
    .matches(whiteSpaceRegex, "No spaces allowed"),
  }),
});

export const validationSchemaReview = Yup.object().shape({
  roomInfoValues: Yup.array()
    .of(
      Yup.object().shape({
        adults: Yup.array()
          .of(personSchema)
          .min(1, "At least one adult is required"),
        childs: Yup.array().of(personSchema),
      })
    )
    .min(1, "At least one room is required"),
  // termsAccepted: Yup.boolean().oneOf(
  //   [true],
  //   "Please accept the terms and conditions"
  // ),
  paymentMethod: Yup.string().required("Please select payment method"),
});
